import { Routes, Route } from 'react-router-dom'; 
import LogIn from './Components/LogIn';
import Navbar from './Components/Navbar';  
import Dashboard from './Components/Dashboard';
import ManageLoans from './Components/ManageLoans';
import ManageRD from './Components/ManageRD';
import ManageFDR from './Components/ManageFDR';
import Footer from './Components/Footer';
import './App.css';

function App() {
  const isLoggedIn = localStorage.getItem("isLoggedIn");

  if (process.env.NODE_ENV === 'production') {
    document.addEventListener('contextmenu', function (e) {
      e.preventDefault();
    }, false);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'F12' || (e.ctrlKey && e.shiftKey && e.key === 'I')) {
        e.preventDefault();
      }
    });
  }

  return (
    <Routes> 
      <Route path="/" element={
        <>
          <LogIn />
        </>
      } />
      <Route path="/Dashboard" element={
        <>
          {isLoggedIn ?
            <>
              <div className='app-container'>
                <Navbar />
                <Dashboard />
                <Footer />
              </div>
            </>
            :
            <>
              <LogIn />
            </>
          }
        </>
      } />  
      <Route path="/ManageLoans" element={
        <>
          {isLoggedIn ?
            <>
              <div className='app-container'>
                <Navbar />
                <ManageLoans />
                <Footer />
              </div>
            </>
            :
            <>
              <LogIn />
            </>
          }
        </>
      } />  
      <Route path="/ManageRD" element={
        <>
          {isLoggedIn ?
            <>
              <div className='app-container'>
                <Navbar />
                <ManageRD />
                <Footer />
              </div>
            </>
            :
            <>
              <LogIn />
            </>
          }
        </>
      } />  
      <Route path="/ManageFDR" element={
        <>
          {isLoggedIn ?
            <>
              <div className='app-container'>
                <Navbar />
                <ManageFDR />
                <Footer />
              </div>
            </>
            :
            <>
              <LogIn />
            </>
          }
        </>
      } />  
    </Routes>
  );
}

export default App;
